/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
 */
export interface ControlcenterMelcoControlCenterModelsUserSerialNumberResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    melco_customer_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    serial_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    display_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    product_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    batch?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    referral?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    product_level_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    product_version_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    product_version_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    product_level_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    product_level_short_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    product_level_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    product_level_description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    is_trial_available?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    number_trial_days?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    saleable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    buy_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    details_url?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    activated_on?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    assigned_user_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    assigned_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    assigned_user_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    assigned_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    expires_on?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    subscription_cost?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    monthly_credits_allowed?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    billing_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    pricing_json?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    downloads_cost?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    duration?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    master_user_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    master_user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    master_name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    is_subscription?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    type?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    license_type?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    status?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    number_of_assigned_machines?: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    cancelled_on?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    bridge_email_address?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    new_subscription_cost?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    is_pending?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    subscription_start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    sub_cancelled_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    renewal_date?: Date | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
}

export function ControlcenterMelcoControlCenterModelsUserSerialNumberResponseFromJSON(json: any): ControlcenterMelcoControlCenterModelsUserSerialNumberResponse {
    return ControlcenterMelcoControlCenterModelsUserSerialNumberResponseFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsUserSerialNumberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsUserSerialNumberResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'melco_customer_id': !exists(json, 'melco_customer_id') ? undefined : json['melco_customer_id'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'serial_number': !exists(json, 'serial_number') ? undefined : json['serial_number'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'referral': !exists(json, 'referral') ? undefined : json['referral'],
        'product_level_id': !exists(json, 'product_level_id') ? undefined : json['product_level_id'],
        'product_version_id': !exists(json, 'product_version_id') ? undefined : json['product_version_id'],
        'product_version_number': !exists(json, 'product_version_number') ? undefined : json['product_version_number'],
        'product_level_code': !exists(json, 'product_level_code') ? undefined : json['product_level_code'],
        'product_level_short_code': !exists(json, 'product_level_short_code') ? undefined : json['product_level_short_code'],
        'product_level_name': !exists(json, 'product_level_name') ? undefined : json['product_level_name'],
        'product_level_description': !exists(json, 'product_level_description') ? undefined : json['product_level_description'],
        'is_trial_available': !exists(json, 'is_trial_available') ? undefined : json['is_trial_available'],
        'number_trial_days': !exists(json, 'number_trial_days') ? undefined : json['number_trial_days'],
        'saleable': !exists(json, 'saleable') ? undefined : json['saleable'],
        'buy_url': !exists(json, 'buy_url') ? undefined : json['buy_url'],
        'details_url': !exists(json, 'details_url') ? undefined : json['details_url'],
        'activated_on': !exists(json, 'activated_on') ? undefined : (json['activated_on'] === null ? null : new Date(json['activated_on'])),
        'assigned_user_id': !exists(json, 'assigned_user_id') ? undefined : json['assigned_user_id'],
        'assigned_name': !exists(json, 'assigned_name') ? undefined : json['assigned_name'],
        'assigned_user_name': !exists(json, 'assigned_user_name') ? undefined : json['assigned_user_name'],
        'assigned_date': !exists(json, 'assigned_date') ? undefined : (json['assigned_date'] === null ? null : new Date(json['assigned_date'])),
        'expires_on': !exists(json, 'expires_on') ? undefined : (json['expires_on'] === null ? null : new Date(json['expires_on'])),
        'subscription_cost': !exists(json, 'subscription_cost') ? undefined : json['subscription_cost'],
        'monthly_credits_allowed': !exists(json, 'monthly_credits_allowed') ? undefined : json['monthly_credits_allowed'],
        'billing_type': !exists(json, 'billing_type') ? undefined : json['billing_type'],
        'pricing_json': !exists(json, 'pricing_json') ? undefined : json['pricing_json'],
        'downloads_cost': !exists(json, 'downloads_cost') ? undefined : json['downloads_cost'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'master_user_id': !exists(json, 'master_user_id') ? undefined : json['master_user_id'],
        'master_user_name': !exists(json, 'master_user_name') ? undefined : json['master_user_name'],
        'master_name': !exists(json, 'master_name') ? undefined : json['master_name'],
        'is_subscription': !exists(json, 'is_subscription') ? undefined : json['is_subscription'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'license_type': !exists(json, 'license_type') ? undefined : json['license_type'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'number_of_assigned_machines': !exists(json, 'number_of_assigned_machines') ? undefined : json['number_of_assigned_machines'],
        'cancelled_on': !exists(json, 'cancelled_on') ? undefined : (json['cancelled_on'] === null ? null : new Date(json['cancelled_on'])),
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'bridge_email_address': !exists(json, 'bridge_email_address') ? undefined : json['bridge_email_address'],
        'new_subscription_cost': !exists(json, 'new_subscription_cost') ? undefined : json['new_subscription_cost'],
        'is_pending': !exists(json, 'is_pending') ? undefined : json['is_pending'],
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : (json['subscription_start_date'] === null ? null : new Date(json['subscription_start_date'])),
        'sub_cancelled_date': !exists(json, 'sub_cancelled_date') ? undefined : (json['sub_cancelled_date'] === null ? null : new Date(json['sub_cancelled_date'])),
        'renewal_date': !exists(json, 'renewal_date') ? undefined : (json['renewal_date'] === null ? null : new Date(json['renewal_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
    };
}

export function ControlcenterMelcoControlCenterModelsUserSerialNumberResponseToJSON(value?: ControlcenterMelcoControlCenterModelsUserSerialNumberResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'melco_customer_id': value.melco_customer_id,
        'language': value.language,
        'id': value.id,
        'serial_number': value.serial_number,
        'display_name': value.display_name,
        'product_code': value.product_code,
        'product_name': value.product_name,
        'batch': value.batch,
        'referral': value.referral,
        'product_level_id': value.product_level_id,
        'product_version_id': value.product_version_id,
        'product_version_number': value.product_version_number,
        'product_level_code': value.product_level_code,
        'product_level_short_code': value.product_level_short_code,
        'product_level_name': value.product_level_name,
        'product_level_description': value.product_level_description,
        'is_trial_available': value.is_trial_available,
        'number_trial_days': value.number_trial_days,
        'saleable': value.saleable,
        'buy_url': value.buy_url,
        'details_url': value.details_url,
        'activated_on': value.activated_on === undefined ? undefined : (value.activated_on === null ? null : value.activated_on.toISOString()),
        'assigned_user_id': value.assigned_user_id,
        'assigned_name': value.assigned_name,
        'assigned_user_name': value.assigned_user_name,
        'assigned_date': value.assigned_date === undefined ? undefined : (value.assigned_date === null ? null : value.assigned_date.toISOString()),
        'expires_on': value.expires_on === undefined ? undefined : (value.expires_on === null ? null : value.expires_on.toISOString()),
        'subscription_cost': value.subscription_cost,
        'monthly_credits_allowed': value.monthly_credits_allowed,
        'billing_type': value.billing_type,
        'pricing_json': value.pricing_json,
        'downloads_cost': value.downloads_cost,
        'duration': value.duration,
        'master_user_id': value.master_user_id,
        'master_user_name': value.master_user_name,
        'master_name': value.master_name,
        'is_subscription': value.is_subscription,
        'type': value.type,
        'license_type': value.license_type,
        'status': value.status,
        'number_of_assigned_machines': value.number_of_assigned_machines,
        'cancelled_on': value.cancelled_on === undefined ? undefined : (value.cancelled_on === null ? null : value.cancelled_on.toISOString()),
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'bridge_email_address': value.bridge_email_address,
        'new_subscription_cost': value.new_subscription_cost,
        'is_pending': value.is_pending,
        'subscription_start_date': value.subscription_start_date === undefined ? undefined : (value.subscription_start_date === null ? null : value.subscription_start_date.toISOString()),
        'sub_cancelled_date': value.sub_cancelled_date === undefined ? undefined : (value.sub_cancelled_date === null ? null : value.sub_cancelled_date.toISOString()),
        'renewal_date': value.renewal_date === undefined ? undefined : (value.renewal_date === null ? null : value.renewal_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
    };
}


